import { render, staticRenderFns } from "./QuizContent.vue?vue&type=template&id=427aeb5b&scoped=true"
import script from "./QuizContent.vue?vue&type=script&lang=js"
export * from "./QuizContent.vue?vue&type=script&lang=js"
import style0 from "./QuizContent.vue?vue&type=style&index=0&id=427aeb5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427aeb5b",
  null
  
)

export default component.exports